jQuery(document).ready(function () {
    const terms = $(".termsCheckBox");
    const matchTerms = terms.length;
    const amenitiesCheckBox = $(".amenitiesCheckBox");
    const matchAmenities = amenitiesCheckBox.length;

    for (let x = 0; x < matchTerms; x++) {
        if (terms[x] === undefined) {
            continue;
        }

        $(terms[x].children[0]).attr('id', 'categories-' + x);
        $(terms[x].children[1]).attr('for', 'categories-' + x);
    }

    for (let x = 0; x < matchAmenities; x++) {
        if (amenitiesCheckBox[x] === undefined) {
            continue;
        }

        $(amenitiesCheckBox[x].children[0]).attr('id', 'amenities-' + x);
        $(amenitiesCheckBox[x].children[1]).attr('for', 'amenities-' + x);
    }

    let toggleSwitch = $('.toggle-switch.range-toggle');

    if (toggleSwitch[1] !== undefined) {
        toggleSwitch[1].children[0].id = 'sidemapRangeToggle';
        toggleSwitch[1].children[1].id = 'sidemapRangeToggleFor';
    }

    $('#sidemapRangeToggleFor').attr('for', 'sidemapRangeToggle');

    $('#filtersToggle').click(function () {
        $('#sidemap').slideToggle();
        blur();
    });

    let showMapEl = $('#show-map');

    showMapEl.click(function () {
        if ($(this).is(':checked')) {
            localStorage.setItem('show-map', 'true');
            $('#sidemap').show();
            $('#search-sidemap').show();
        } else {
            localStorage.removeItem('show-map');
            $('#sidemap').hide();
            $('#search-sidemap').hide();
        }

        if ($('.terms-group-map').length === 0) {
            init_map();
        }

        prepareContent();
    });

    if (window.innerWidth >= 1741 && localStorage.getItem('show-map') !== null) {
        showMapEl.click();
    }

    let map = $('#map');
    let sticky = null;

    $(window).scroll(function () {
        if (map.is(":visible")) {
            let pos = $(window).scrollTop();

            let mapOffsetTop = map.offset().top;

            if (sticky === null) sticky = mapOffsetTop;

            if (pos > sticky) {
                map.addClass('sticky');
            } else {
                map.removeClass('sticky');
            }
        }
    });
});

function addMarkerToGroup(group, coordinate, html) {
    const svgMarkup = '<svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px"><circle cx="10" cy="10" r="10" fill="#1080DD" /></svg>';

    let customIcon = new H.map.Icon(svgMarkup, {
        size: {w: 20, h: 20}
    });

    let marker = new H.map.Marker(coordinate, {
        icon: customIcon
    });

    marker.setData(html);
    marker.setZIndex(1);

    group.addObject(marker);
}

function openPopup(evt, map, ui) {
    let bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
        content: evt.target.getData()
    });

    ui.getBubbles().forEach(bub => {
        if (bub instanceof H.ui.InfoBubble) {
            try {
                ui.removeBubble(bub);
            } catch (e) {
                $('.H_ib.H_ib_top.H_el').remove();
            }
        }
    });

    ui.addBubble(bubble);
}

function startClustering(map, data, ui, group) {
    Object.keys(data).map(function (item) {
        let opened, menuAndReserve = '';

        let image = `${window.rootUrl}/assets/img/tmp/placeholder_restaurant.jpg`;

        if (data[item].main_image_url) {
            image = data[item].main_image_url;
        }

        if (data[item].closed === true) {
            opened = `<div class="open closed">${window.translations.restaurant_closed}</div>`;
        } else {
            opened = `<div class="open opened">${window.translations.restaurant_opened}</div>`;
        }

        if (data[item].dishes_count > 0 || data[item].external_reservation || data[item].internal_reservation) {
            menuAndReserve += '<hr><div class="listing-menu-reserve">';

            if (data[item].dishes_count > 0) {
                menuAndReserve += `<div class="menu" title="${window.translations.menu_on_hover}">
                        <div class="lnr-wrapper">
                            <span class="lnr lnr-2x lnr-dinner fix-position lnr-green"></span>
                            <span>${window.translations.menu}</span>
                        </div>
                    </div>`;
            }

            if (data[item].external_reservation || data[item].internal_reservation) {
                menuAndReserve += ` <div class="reserve" title="${window.translations.reserve_on_hover}">
                        <div class="lnr-wrapper">
                            <span class="lnr lnr-2x lnr-calendar-full fix-position lnr-green"></span>
                            <span>${window.translations.reserve_now}</span>
                        </div>
                    </div>`;
            }

            menuAndReserve += '</div>';
        }

        let details = `<div class='card-map' data-id='${data[item].id}'>
            <div class='image-map' style='background-image: url(${image});'></div>

            <div class='details-map'>
                <h5>
                    <a href='/restaurants/${data[item].city.slug}/${data[item].new_slug}'>
                        ${data[item].name}
                    </a>
                </h5>

                <div class="rating-price-open mt-5">
                    <div class="d-flex" style="align-items: center; flex-wrap: wrap;">
                        <div class="listing-stars" style="width: 54px; display: ${data[item].rating ? 'block' : 'none'}">
                            ${data[item].rating ? Math.floor(data[item].rating) : 0} <i class="lnr lnr-star"></i>
                        </div>
                        ${opened}
                    </div>
                </div>

                ${menuAndReserve}
            </div>
        </div>`;

        addMarkerToGroup(group, {lat: data[item].location.lat, lng: data[item].location.lon}, details);

        var lat = data[item].location.lat;
        var lng = data[item].location.lon;

        let bubble = new H.ui.InfoBubble({lat: lat, lng: lng}, {
            content: details,
        });

        // bubble.setState('closed');

        ui.addBubble(bubble);

        bubble.close();
    });
}

function prepareContent() {
    let container = $('#container');
    let listing = $('#listing');
    let amenities = $('#amenities');
    let amenitiesList = $('#amenitiesList');
    let categories = $('#categories');
    let categoriesList = $('#categoriesList');

    container.toggleClass('container fluid-container');
    container.toggleClass('p-5');

    $('#sidebar').toggle();
    $('.cards-row').toggleClass('p-10');

    listing.toggleClass('col-md-9 col-md-6');

    $('#rating').toggleClass('widget widget-rating-inline');
    $('#searchRestaurants').toggleClass('filter filter-mapsearch');

    categories.toggleClass('d-flex');
    categories.toggleClass('categories');
    categoriesList.toggleClass('w-100');
    categoriesList.toggleClass('background-white');
    $('#categoriesGroup').toggleClass('d-flex');

    amenities.toggleClass('d-flex');
    amenities.toggleClass('amenities');
    amenitiesList.toggleClass('w-100');
    amenitiesList.toggleClass('background-white');
    $('#amenitiesGroup').toggleClass('d-flex');

    $('#range').toggleClass('range');
    $('#rangeButton').toggleClass('d-none');

    var terms = $(".termsCheckBox");
    var matchTerms = Math.floor(terms.length / 2);
    var amenitiesCheckBox = $(".amenitiesCheckBox");
    var matchAmenities = Math.floor(amenitiesCheckBox.length / 2);


    if ($('.terms-group-map').length === 0) {
        for (var i = 0; i < matchTerms; i += 3) {
            terms.slice(i, i + 3).wrapAll("<div id='termsGroupMap-" + i + "' class='list terms-group-map d-grid'></div>");
        }
    }
    if ($('.amenities-group-map').length === 0) {
        for (var j = 0; j < matchAmenities; j += 3) {
            amenitiesCheckBox.slice(j, j + 3).wrapAll("<div id='amenitiesGroupMap-" + j + "' class='list amenities-group-map d-grid'></div>");
        }
    }

    $('#filtersToggle').toggleClass('d-none d-block');
    blur();

    $('#map').toggle();
}

window.bubbleOpened = null;

function init_map() {
    loadMapScripts()
        .then(function () {
            setTimeout(async () => {

                let zoom = window.searching === 1 ? 4 : 2;
                let zoomMap = window.searchByCity === '1' ? 11 : zoom;

                let centerMap = {lat: window.restaurantLat, lng: window.restaurantLng};

                let platform = new H.service.Platform({
                    apikey: window.hereMapsKey
                });

                let defaultLayers = platform.createDefaultLayers();

                let map = false;
                map = new H.Map(document.getElementById('mapdiv'),
                    defaultLayers.raster.normal.map, {
                        center: centerMap,
                        zoom: zoomMap,
                        pixelRatio: window.devicePixelRatio || 1
                    });

                window.addEventListener('resize', () => map.getViewPort().resize());

                new H.mapevents.Behavior(new H.mapevents.MapEvents(map));

                let ui = H.ui.UI.createDefault(map, defaultLayers);

                let group = new H.map.Group();

                map.addObject(group);

                map.addEventListener('pointermove', function (evt) {
                    if (evt.target instanceof H.map.Marker) {
                        map.getViewPort().element.style.cursor = 'pointer';
                    } else {
                        map.getViewPort().element.style.cursor = 'auto';
                    }
                }, false);

                map.addEventListener('tap', function (evt) {
                    $('.H_ib.H_ib_top.H_el').remove();
                    $('#mapdiv > div').css('overflow', 'hidden');

                    if (evt.target instanceof H.map.Marker) {
                        let iconUid = evt.target.icon.uid;

                        if (window.bubbleOpened === iconUid) {
                            return;
                        }

                        window.bubbleOpened = iconUid;

                        openPopup(evt, map, ui);

                        setTimeout(() => {
                            $('#mapdiv > div').css('overflow', 'unset');
                        }, 50);
                    } else {
                        window.bubbleOpened = null;
                    }
                }, false);

                $('.restaurants-listing-parrent').hover(function (e) {

                    let objects = group.getObjects(),
                        len = group.getObjects().length,
                        i;

                    for (i = 0; i < len; i += 1) {
                        let data = objects[i].getData();

                        if (data.indexOf($(this).data('id')) !== -1) {
                            const svgMarkup = '<svg height="40" width="40" xmlns="http://www.w3.org/2000/svg">' +
                                '<circle cx="20" cy="20" r="20" fill="#7f9741" /></svg>';

                            const customIcon = new H.map.Icon(svgMarkup);

                            objects[i].setIcon(customIcon);
                            objects[i].setZIndex(0);
                        }
                    }
                }, function () {
                    let objects = group.getObjects(),
                        len = group.getObjects().length,
                        i;

                    const svgMarkup = '<svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">' +
                        '<circle cx="10" cy="10" r="10" fill="#1080DD" /></svg>';

                    for (i = 0; i < len; i += 1) {
                        const customIcon = new H.map.Icon(svgMarkup);
                        objects[i].setIcon(customIcon);
                        objects[i].setZIndex(1);
                    }

                });

                if (window.searching === 0) {
                    let url = window.restaurantListingMap;

                    axios({
                        method: 'post',
                        url: url,
                        data: {
                            restaurants_id: JSON.parse(window.restaurantsId)
                        }
                    })
                        .then(function (response) {
                            startClustering(map, response.data.data, ui, group);
                        })
                        .catch(function (error) {
                            iziToast.show({
                                title: error.message,
                                color: 'red'  // blue, red, green, yellow
                            });

                            $('#show-map').click();
                        });
                } else if (window.searching === 1) {
                    let searchUrl = window.location.href;
                    let urlObj = new URL(searchUrl);

                    if (urlObj.search) {
                        searchUrl += '&restaurants-map';
                    } else {
                        searchUrl += '?restaurants-map';
                    }

                    axios({
                        method: 'get',
                        url: searchUrl
                    })
                        .then(function (response) {
                            startClustering(map, response.data, ui, group);
                        });
                }
            }, 1000);
        });
}

function loadMapScripts() {
    return new Promise((resolve, reject) => {
        const {['main']: main, ...rest} = JSON.parse(window.hereMapsScript);
        let i = 0;

        loadScript(window.hereMapsStyle, 'css');

        loadScript(main, 'js', function () {
            Object.keys(rest).forEach(key => {
                i++;

                if (key !== 'clustering') {
                    loadScript(rest[key]);
                }

                if (i >= objectLength(rest)) {
                    resolve(true);
                }
            });
        });
    });
}

function loadScript(url, type = 'js', callback) {
    let head = document.head, element;

    if (type === 'css') {
        element = document.createElement("link");
        element.rel = "stylesheet";
        element.type = "text/css";
        element.href = url;
    } else {
        element = document.createElement('script');
        element.type = 'text/javascript';
        element.src = url;
    }

    if (callback) {
        element.onreadystatechange = callback;
        element.onload = callback;
    }

    head.appendChild(element);
}

function objectLength(object) {
    let length = 0;

    for (let key in object) {
        if (object.hasOwnProperty(key)) {
            ++length;
        }
    }
    return length;
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/sidemap.js